
export default {
  props: {
    bid: {
      type: Object,
      required: false,
      default: undefined
    },

    bidCount: {
      type: Number,
      default: 0
    },

    tenderProcedureType: {
      type: String,
      default: '',
      required: false
    },

    publication: {
      type: Object,
      required: false
    }
  }
};
